// Company APIS
export const API_GET_COMPANY_CONFIGURATION = (companyId: string) =>
  `/api/${companyId}/web-app/configuration`;
export const API_GET_COMPANY_LOYALTY = (companyId: string) =>
  `/api/${companyId}/configuration/loyalty`;
export const API_GET_COMPANY_CHATBOT_LINK = (companyId: string) =>
  `/api/${companyId}/configuration/chatbot/link`;

// User APIS
export const API_DECISION_2FA_API = (companyId) =>
  `/api/${companyId}/2fa/decision`;
export const API_VERIFY_2FA_API = (companyId) => `/api/${companyId}/2fa/verify`;

export const API_GET_USER = (companyId: string, userId: string) =>
  `/api/${companyId}/users/${userId}`;

export const API_PUT_USERS_SHOP_DATA = (
  companyId: string,
  userId: string,
  shopId: string,
) => `/api/${companyId}/users/${userId}/shops/${shopId}`;

export const API_CUSTOMER_TRANSFER = (companyId: string) =>
  `/api/${companyId}/customers/transfer`;

export const API_DELETE_USER_ORDER = (
  companyId: string,
  userId: string,
  orderId: string,
) => `/api/${companyId}/users/${userId}/last-order-ids/${orderId}`;

export const API_USER_PROMO_CODE = (
  companyId: string,
  userId: string,
  promoCodeKey: string,
) => `/api/${companyId}/users/${userId}/promotions/${promoCodeKey}`;

// Device APIS
export const API_DEVICE_USED_PROMO_CODE = (
  companyId: string,
  deviceId: string,
  promoCodeKey: string,
) => `/api/${companyId}/devices/${deviceId}/used-promo-code/${promoCodeKey}`;

// Shop APIS
export const API_SHOPS = (companyId: string) => `/api/${companyId}/shops`;
export const API_SHOP_ADDRESS = (companyId: string, shopId: string) =>
  `/api/${companyId}/shops/${shopId}/address`;

// Pending Order APIS
export const API_PENDING_ORDER = (companyId: string, userId: string) =>
  `/api/${companyId}/users/${userId}/pending-order`;

export const API_PENDING_ORDER_BASKET = (companyId: string, userId: string) =>
  `/api/${companyId}/users/${userId}/pending-order/basket`;

export const API_PENDING_ORDER_BASKET_ITEM = (
  companyId: string,
  userId: string,
  itemKey: string,
) => `/api/${companyId}/users/${userId}/pending-order/basket/${itemKey}`;

export const API_GET_SHOP_ORDER_SLOTS = (companyId, customerId) =>
  `/api/${companyId}/users/${customerId}/shop-order-slots`;

// Delivery APIS
export const API_AVAILABLE_SHOPS = (companyId: string) =>
  `/api/${companyId}/available-shops`;
export const API_PENDING_ORDER_VALIDITY_CHECK = (
  companyId: string,
  userId: string,
) => `${API_PENDING_ORDER(companyId, userId)}/validity`;

export const API_PENDING_ORDER_DELIVERY_INSTRUCTIONS = (
  companyId: string,
  userId: string,
) => `${API_PENDING_ORDER(companyId, userId)}//delivery-instructions`;

export const API_DIRECTIONS_FROM_COORDINATES = (companyId: string) =>
  `/api/${companyId}/google/directions/from-coordinates`;
